import React,{useEffect,useState} from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Tab, Form,Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import { Flip, Slide, toast } from 'react-toastify';
import CustomTable from './CustomTable'
import "./Contract.styles.css";

const Contract = () => {

  const [logedIn, setLogedIn] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [contracts, setContracts] = useState(false);
    const [selectedContract, setSelectedContract] = useState(false);
    const [dmShow, setDmShow] = useState(false);
    const [emShow, setEmShow] = useState(false);
    const [editPermission, setEditPermission] = useState(false);
    const [deletePermission, setDeletePermission] = useState(false);
    const [viewPermission, setViewPermission] = useState(false);

    async function getContracts () {
        // userDetails.arnum="ARM-90212518";
        await Axios.get(`/corporate/contract/${userDetails.arnum}`)
        .then(async (catalogs) => {
            if (catalogs.status == 200 && catalogs.data?.data?.contracts) {
              setContracts(catalogs.data.data.contracts);
            }
        })
    }

    async function addNewCatalog (values) {
        await Axios.post(`/corporate/catalog/${userDetails.arnum}`,{
          "catalog": {
            "catalogname": values.catalogname
          }
        })
        .then(async (catalogs) => {
          getContracts(userDetails.refnum);
          toast.success('New catalog added successfully', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
          });
          setEmShow(false);
        })
    }

    async function deleteCatalog () {
      if(selectedContract){
        await Axios.delete(`/corporate/catalog/${userDetails.arnum}/${selectedContract}`)
        .then(async (catalogs) => {
          getContracts(userDetails.refnum);
          toast.success('Catalog deleted successfully', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
          });
          setDmShow(false);
        })
      }
    }

    useEffect(() => {
        setViewPermission(AuthVerify.getPermissions("MyContracts")?.view);
        setEditPermission(AuthVerify.getPermissions("MyContracts")?.edit);
        setDeletePermission(AuthVerify.getPermissions("MyContracts")?.delete);
        setLogedIn(AuthVerify.isUserLogedIn());
    }, []);

    useEffect(() => {
        if(logedIn)setUserDetails(AuthVerify.getUser());
    }, [logedIn]);

    useEffect(() => {
        if(userDetails)getContracts(userDetails.refnum);
    }, [userDetails]);


  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>My Contracts</h2>
          {/* <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus
                  </p> */}
        </div>
            <div className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                    
                                    <div className="box-border" style={{margin:"auto",width:"100%",padding:"0"}}>
                                      <CustomTable/>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
      </div>
    </div>
  );
};

export default Contract;
